import BaseService from "../baseService";
class EmailExterno extends BaseService {
    constructor(id) {
        const resource = "email-externo";
        let relationship = {};
        super(id, relationship, resource);
    }
}

export default (id) => new EmailExterno(id);
